import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=7e40fa30&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&id=7e40fa30&scoped=true&lang=css&"
import style1 from "./goods.vue?vue&type=style&index=1&id=7e40fa30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e40fa30",
  null
  
)

export default component.exports